<p>{{ input().message }}</p>
